(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("scratchCard", [], factory);
	else if(typeof exports === 'object')
		exports["scratchCard"] = factory();
	else
		root["scratchCard"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition